
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CStepSubGroup',
  props: {
    title: { required: true, type: String },
  },
})
